import { useCallback, useMemo } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getBusinessOrganizations } from "../data/organizations";
import { mapOrganizationToPage } from "../presentation/organizations/organizationPage.mapper";
import type { OrganizationPageData } from "../presentation/organizations/organizationPage.types";
import { resolveBusinessId } from "../routes/businessRoutes";

export type {
  OrganizationPageData as BusinessPageData,
  OrganizationPageProduct as BusinessPageProduct,
  OrganizationPageVideo as BusinessPageVideo,
} from "../presentation/organizations/organizationPage.types";

export const useBusinessPageData = () => {
  const { language } = useLanguage();

  const businesses = useMemo<OrganizationPageData[]>(
    () => getBusinessOrganizations().map((organization) => mapOrganizationToPage(organization, language)),
    [language]
  );

  const getBusinessById = useCallback(
    (id: string): OrganizationPageData | undefined =>
      businesses.find((business) => business.id === resolveBusinessId(id)),
    [businesses]
  );

  return { businesses, getBusinessById };
};
